import React from 'react';
import Icon from './Icon';
import './EmptyState.css';

/**
 * A contextual empty state — says what is missing in the product's voice and offers the next move.
 * Never a generic "No data found". `art` uses the supplied illustration for the icon when one exists.
 *
 *   <EmptyState icon="mistake" title="Nothing to recover yet" body="Keep practising." action={{ label: 'Start a challenge', onClick }} />
 */
export default function EmptyState({ icon = 'sparkle', art = true, title, body, action, compact = false, tone = 'violet' }) {
  return (
    <div className={`z-empty${compact ? ' z-empty--compact' : ''} z-empty--${tone}`} role="status">
      <span className="z-empty-art"><Icon name={icon} art={art} size={compact ? 44 : 64} /></span>
      <h3 className="z-empty-title">{title}</h3>
      {body && <p className="z-empty-body">{body}</p>}
      {action && (
        <button type="button" className={`z-btn ${action.secondary ? 'z-btn--secondary' : 'z-btn--primary'} z-empty-action`} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
